import clsx from "clsx";
import { FC, useEffect, useRef, useState } from "react";

import { AlertMedia } from "@/utilities/types/alert";
import MediaErrorPlaceholder from "@/views/alerts/AlertsPage/AlertItem/AlertClip/MediaErrorPlaceholder/MediaErrorPlaceholder";

import useStyles from "./AlertClip.styles";


export interface AlertClipProps {
    play: boolean;
    thumbnail?: AlertMedia;
    video?: AlertMedia;
}

const AlertClip: FC<AlertClipProps> = ({ play, thumbnail, video }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [videoError, setVideoError] = useState(false);
    const [thumbnailError, setThumbnailError] = useState(false);

    useEffect(() => {
        if (play && videoRef.current) videoRef.current.play();
        else if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    }, [play, videoRef.current]);

    const classes = useStyles();

    return (
        <div className={classes.clip}>
            {video && !videoError ?
                <video
                    loop
                    muted
                    src={video.url}
                    className={clsx(classes.video, { [classes.hidden]: !play })}
                    ref={videoRef}
                    onError={() => setVideoError(true)}
                />
                :
                <MediaErrorPlaceholder className={clsx({ [classes.hidden]: !play })}/>
            }

            {thumbnail && !thumbnailError ?
                <img
                    src={thumbnail.url}
                    className={clsx(classes.thumbnail, { [classes.hidden]: play })}
                    alt={`${thumbnail.cameraRole} camera screenshot`}
                    onError={() => setThumbnailError(true)}
                />
                :
                <MediaErrorPlaceholder className={clsx({ [classes.hidden]: play })}/>
            }
        </div>
    );
};

export default AlertClip;
